import * as React from 'react';

import { cn } from '@/new/lib/utils';

const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'flex field-sizing-content min-h-[60px] w-full rounded-md border bg-white px-3 py-2 ring-offset-2 ring-offset-transparent placeholder:text-gray-400/80 focus-visible:ring-1 focus-visible:ring-teal-500 focus-visible:ring-offset-white focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
